import {ActionFormDialog, type MejoraEditada, type OrigenMejora} from '@/components/action-form-dialog'
import {useResponsablesRoster} from '@/hooks/empresa/identidad/use-employees'

/** Cadencia PLANEAR (+30 días) del backend; solo prellena: la fecha guardada la confirma el dueño. */
const DIAS_MEJORA = 30

function fechaSugerida(dias = DIAS_MEJORA): string {
  // nosemgrep: browser-clock-business-date -- valor por defecto de un input de fecha, dato editable que el dueño confirma; la fecha guardada viaja explícita al backend
  const hoy = new Date()
  hoy.setDate(hoy.getDate() + dias)
  return hoy.toISOString().slice(0, 10)
}

/** D4. Envuelve el `ActionFormDialog` del plan y agrega el roster y el endpoint del origen, que
 * crea la FK y mantiene su idempotencia. */
export function CrearMejoraDialog({
  businessId,
  open,
  onOpenChange,
  origen,
  descripcion,
  descripcionPlaceholder,
  responsableId,
  fecha,
  standardCode,
  standardName,
  onCrear,
}: {
  businessId: string
  open: boolean
  onOpenChange: (open: boolean) => void
  origen: OrigenMejora
  descripcion: string
  descripcionPlaceholder?: string
  responsableId?: string | null
  fecha?: string
  standardCode?: string | null
  standardName?: string
  onCrear: (valores: MejoraEditada) => Promise<unknown>
}) {
  const {data: roster} = useResponsablesRoster(open ? businessId : undefined, true)
  return (
    <ActionFormDialog
      businessId={businessId}
      open={open}
      onOpenChange={onOpenChange}
      standardCode={standardCode ?? null}
      standardName={standardName}
      roster={roster ?? []}
      evidence={[]}
      initialDescription={descripcion}
      descripcionPlaceholder={descripcionPlaceholder}
      initialResponsibleId={responsableId ?? null}
      initialTargetDate={fecha ?? fechaSugerida()}
      origen={origen}
      onCrear={onCrear}
    />
  )
}
